// @flow

// force flow to type check this file - https://github.com/zapier/zapier/pull/31127
/* eslint-disable-next-line no-unused-vars */
import React, { type Node } from 'react';
import { clamp } from 'lodash';

import { isolateComponent, useHeadingLevel } from '@zapier/common-utils';
import { type CssProp } from '@zapier/design-system';

/** @jsx isolateComponent */

type Props = {|
  /**
   * The content to render for the heading.
   */
  children: Node,
  /**
   * The string provided by the `css` prop via emotion.
   * This should only ever be provided by the `css` prop!
   */
  className?: string,
  /**
   * The `css` prop for emotion. Enumerated
   * here to keep flow from complaining.
   */
  css?: CssProp,
|};

/**
 * Renders an `h*` tag of the appropriate level, based on how
 * deeply nested within the `HeadingLevel` hierarchy the component is.
 *
 * Tags: core-ui
 */
const Heading = (props: Props) => {
  const { level } = useHeadingLevel();
  const headingLevel = clamp(level, 1, 6);
  const Tag = `h${headingLevel}`;
  return <Tag className={props.className}>{props.children}</Tag>;
};

export default Heading;
